var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgCallScheduled = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "20px",
    viewBox: "0 0 17 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "call scheduled")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MacBookPro-2017",
    transform: "translate(-49.000000, -75.000000)",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call-scheduled",
    transform: "translate(50.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11,
    cy: 5,
    r: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(0.000000, 5.000000)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3929558,1.24344979e-14 L4.3929558,2 C5.3929558,3 5.3929558,3 4.3929558,4 C3.72628913,4.66666667 3.72628913,5.33333333 4.3929558,6 L4.3929558,6 L6.3929558,8 L8.16567522,9.43535592 C8.8552021,10.0783501 9.52146266,10.0550838 10.1644569,9.36555693 C11.1289482,8.33126661 11.1289482,8.33126661 12.1632385,9.29575794 C12.8527654,9.93875216 13.5422923,10.5817464 14.2318192,11.2247406 C14.2318192,11.2247406 13.9103221,11.569504 13.2673278,12.2590309 C12.3028365,13.2933212 11.3732447,15.3270024 7.23608339,11.4690371 C5.34156372,9.82379283 4.06083743,8.66776336 3.39390453,8.00094865 C2.72628913,7.33333333 2.3929558,7 2.3929558,7 C-1.6070442,3 0.392955796,2 1.3929558,1 C1.77390818,0.619047619 2.04601702,0.346938776 2.20928233,0.183673469 L2.3929558,1.24344979e-14 L2.3929558,1.24344979e-14 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    strokeLinecap: "round",
    points: "11 3 11 5 9 5"
  }))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCallScheduled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/call-scheduled.f8f55fc0.svg";
export { ForwardRef as ReactComponent };